import { render, staticRenderFns } from "./ProductosAuditoria.vue?vue&type=template&id=797cb5f2"
import script from "./ProductosAuditoria.vue?vue&type=script&lang=js"
export * from "./ProductosAuditoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports